import { createMutation } from '$lib/api/tanstack-query';

import type { ExtendRobotReservationRequest } from '@viamrobotics/web-client/robotreservation/v1/robot_reservation';

import { useAuthContext } from '$lib/auth';

import { useRobotReservationClient } from '../client';
import { useQueryInvalidator } from '../invalidate';
import { tryAdminKeys, tryReservationsKeys } from './query-keys';

export const createExtendTryReservationMutation = () => {
  const { getRPCOptions } = useAuthContext();
  const client = useRobotReservationClient();
  const { invalidateQueries } = useQueryInvalidator();

  return createMutation({
    mutationFn: async (request: ExtendRobotReservationRequest) => {
      const rpcOptions = await getRPCOptions();
      return client.extendRobotReservation(request, rpcOptions);
    },
    onSuccess: async (_data, { id }) => {
      await invalidateQueries([
        tryReservationsKeys.active(),
        tryReservationsKeys.detail(id),
        tryAdminKeys.lists(),
      ]);
    },
  });
};
